import { store } from '@/store';
import { computed, watch } from 'vue';
import { globalData } from '@/global';
import types from '@/store/types';

export function useTrack () {
  const ready = computed<boolean>(() => store.getters.pvDataReady);

  const saData = computed(() => {
    const isShare = store.state.isShare;
    const PageID = isShare ? '活动页-受邀者视角' : '活动页-发起者视角';
    const currentMembers = store.state.currentMembers;
    const myInfo =
      currentMembers.length > 0
        ? store.state.currentMembers.find(
          (member) => member.userId === store.state.user.uid
        )
        : {
          obtainCount: 0,
          inviteNewUserCount: 0,
          inviteOldUserCount: 0,
        };
    const CoinAmount = myInfo?.obtainCount || 0;
    const NewUser = myInfo?.inviteNewUserCount || 0;
    const OldUser = myInfo?.inviteOldUserCount || 0;
    const TeamCoinAmount =
      currentMembers.length > 0 ? store.state.teamMinObtain : 0;
    const TeamNumber = currentMembers.length;
    const CaptianUID =
      currentMembers.length > 0 ? `${store.state.teamLeaderUid}` : '未组队';
    const TeamRanking =
      currentMembers.length > 0
        ? store.state.myTeamRank.rank > 99
          ? '99+'
          : `${store.state.myTeamRank.rank}`
        : '0';
    const shareUID = store.state.shareExtendInfo.inviteUserId;
    return {
      isShare,
      Visit_Source: globalData.visitsource,
      PageID,
      CoinAmount,
      NewUser,
      OldUser,
      TeamCoinAmount,
      TeamNumber,
      CaptianUID,
      TeamRanking,
      shareUID,
      ActivityMark: 'shareforKKB_team',
    };
  });

  watch(ready, () => {
    trackPV();
  });

  function trackPV () {
    if (store.state.pvTracked) {
      return;
    }
    if (saData.value.isShare) {
      kksa.track('ActivityPV', {
        Visit_Source: saData.value.Visit_Source,
        ActivityMark: saData.value.ActivityMark,
        PageID: saData.value.PageID,
        TeamCoinAmount: saData.value.TeamCoinAmount,
        TeamNumber: saData.value.TeamNumber,
        CaptianUID: saData.value.CaptianUID,
        TeamRanking: saData.value.TeamRanking,
        shareUID: saData.value.shareUID,
      });
    } else {
      kksa.track('ActivityPV', {
        Visit_Source: saData.value.Visit_Source,
        ActivityMark: saData.value.ActivityMark,
        PageID: saData.value.PageID,
        CoinAmount: saData.value.CoinAmount,
        NewUser: saData.value.NewUser,
        OldUser: saData.value.OldUser,
        TeamCoinAmount: saData.value.TeamCoinAmount,
        TeamNumber: saData.value.TeamNumber,
        CaptianUID: saData.value.CaptianUID,
        TeamRanking: saData.value.TeamRanking,
      });
    }
    store.commit(types.SET_PV_TRACKED);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function trackBtn (btnName: string, param:any = {}) {
    kksa.track('ActivityBtnClkH5', Object.assign({
      ButtonName: btnName,
      Visit_Source: saData.value.Visit_Source,
      ActivityMark: saData.value.ActivityMark,
      PageID: saData.value.PageID,
      CaptianUID: saData.value.CaptianUID,
      shareUID: saData.value.shareUID,
    }, param));
  }

  function trackPopup (popupName: string) {
    kksa.track('ActivityPopup', {
      Visit_Source: saData.value.Visit_Source,
      ActivityMark: saData.value.ActivityMark,
      PageID: saData.value.PageID,
      popupName
    });
  }

  function trackPopupBtn (popupName: string, btnName: string) {
    kksa.track('ActivityPopupBtnClkH5', {
      Visit_Source: saData.value.Visit_Source,
      ActivityMark: saData.value.ActivityMark,
      PageID: saData.value.PageID,
      popupName,
      ButtonName: btnName
    });
  }
  return { trackBtn, trackPopup, trackPopupBtn };
}
